<template>
  <div class="modal">
    <span class="modal__trigger" @click="toggleModal()"><slot name="trigger"></slot></span>
    <div class="modal__overlay" v-if="modalShowing">
      <a class="cm-button modal__trigger modal__trigger--inner" @click="toggleModal()"><i class="ss-icon">close</i></a>
      <div class="modal__content">
        <div class="modal__inner-content">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        modalShowing: false
      }
    },

    methods: {
      toggleModal () {
        this.modalShowing = !this.modalShowing;
      }
    }
  }
</script>

<style scoped lang="sass">
  .modal
    &__overlay
      display: flex
      width: 100%
      height: 100%
      background: rgba(0, 0, 0, 0.5)
      position: fixed
      z-index: 2
      top: 0
      left: 0
      align-items: center
      justify-content: center
      flex-direction: column

    &__content
      border-top: 5px solid #000
      max-height: 80%
      width: 80%
      background: #fff
      z-index: 2
      margin: 0 auto
      position: relative
      overflow: scroll

    &__trigger
      cursor: pointer

      &--inner
        background: #fff
        color: #000
        margin-left: auto !important
        height: 25px
        width: 25px
        padding: 0
        margin-right: 10%
        margin-bottom: 10px

        i
          position: relative
          top: 4px

        &:hover
          border: 0
          background: #fff
          color: #000
          padding: 0
</style>



// WEBPACK FOOTER //
// app/javascript/components/modal.vue?5b0d5029